<template>
  <el-dialog
      :close-on-click-modal="false"
      ref="regDialog"
      :visible.sync="pshow"
      @open="resetFgPwdForm"
      class="fgpwd-dialog"
      width="500px">
      <div class="tp-fgpwd-dia-header" slot="title">
        忘记密码
      </div>

      <!-- 忘记form -->
        <div class="tp-fgpwd-form-w">
          <el-form ref="fgPwdForm" :model="fgPwdForm" label-position="right"  label-width="100px">
            <div class="tp-f-item">
              <el-form-item label="手机号码" class="u-pwd-phone" prop="phone" :rules="rule.phone">
                <el-input :disabled="phoneDisabled" placeholder="请输入手机号码" v-model="fgPwdForm.phone" @input="onInputMobile"></el-input>
              </el-form-item>
            </div>

            <div class="tp-f-item" v-if="accounts.length > 1">
              <el-form-item label="账号名称" class="u-pwd-auth-c" prop="account" :rules="rule.required">
                <el-select style="width: 100%" v-model="fgPwdForm.account" placeholder="请选择登录账号">
                  <el-option
                    v-for="item in accounts"
                    :key="item.username"
                    :label="item.username"
                    :value="item.username">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="tp-f-item">
              <el-form-item label="验证码" class="u-pwd-auth-c" prop="authCode" :rules="rule.required">
                <auth-code
                  ref="authCodeInput"
                  :phoneNum="fgPwdForm.phone"
                  :isForget="true"
                  v-model="fgPwdForm.authCode"
                  @authCodeChange="setNewAuthCode">
                </auth-code>
              </el-form-item>
            </div>

            <div class="grid-content">
              <el-form-item label="设置新密码" prop="pwd" :rules="rule.pwd">
                <el-input type="password" show-password placeholder="请输入新密码（6-20个字符）" v-model="fgPwdForm.pwd"></el-input>
              </el-form-item>
            </div>
            <div class="grid-content">
              <el-form-item label="确认密码" prop="repPwd" :rules="repFgPwdValidator">
                <el-input placeholder="请再次输入新密码" type="password" show-password v-model="fgPwdForm.repPwd"></el-input>
              </el-form-item>
            </div>

            <div class="tp-fgpwd-buttom-bt">
              <el-button style="width:60%" class="btn" type="primary" @click="onFgPwdSub">确定</el-button>
            </div>
          </el-form>
        </div>
    </el-dialog>
</template>

<script>
import rule from '@/util/rule'
import API from '@/api/api'
import AuthCode from '@/components/auth-code'

export default {
  name: 'ForgetPassword',
  props: ['dialogShow'],
  data () {
    return {
      rule,
      // 忘记form
      fgPwdForm: {
        phone: '',
        authCode: '',
        pwd: '',
        repPwd: '',
        account: ''
      },
      phoneDisabled: false,
      accounts: [],
      repFgPwdValidator: {
        required: true,
        validator: (rule, value, cb) => {
          if (!value) {
            return cb(new Error('确认密码不能为空'))
          } else if (this.fgPwdForm.pwd !== value) {
            return cb(new Error('两次输入的密码不一致，请检查'))
          } else {
            cb()
          }
        },
        trigger: 'blur'
      }
    }
  },
  watch: {

  },
  computed: {
    pshow: {
      get () {
        return this.dialogShow
      },
      set (v) {
        if (!v) {
          this.$emit('fgtShowUpdate', false)
        }
      }
    }
  },
  methods: {
    // 获取AuthCode
    setNewAuthCode (newVal) {
      this.fgPwdForm.authCode = newVal
    },
    resetFgPwdForm () {
      this.fgPwdForm.phone = ''
      this.fgPwdForm.pwd = ''
      this.fgPwdForm.repPwd = ''
      this.fgPwdForm.authCode = ''
      this.fgPwdForm.account = ''
      this.accounts = []
      this.phoneDisabled = false
      // this.$emit('fgtShowUpdate', false)
    },
    // 提交忘记form
    async onFgPwdSub () {
      this.$refs.fgPwdForm.validate(async valid => {
        if (valid) {
          // this.loading = true
          try {
            const res = await API.updatePwd({
              code: this.fgPwdForm.authCode,
              mobile: this.fgPwdForm.phone,
              password: this.fgPwdForm.pwd,
              username: this.fgPwdForm.account
            })
            if (res.data.statusCode === '200') {
              this.$message({
                message: res.data.result,
                type: 'success'
              })
              this.pshow = false
            } else {
              throw new Error(res.data.result)
            }
          } catch (e) {
            // this.$message({
            //   message: e.message,
            //   type: 'error'
            // })
          }
        }
      })
    },
    onInputMobile (v) {
      const reg = /^1[3456789]\d{9}$/
      if (reg.test(v)) {
        this.getMembersByMobile()
      } else {
        this.accounts = []
        this.usrDisabled = false
      }
    },
    async getMembersByMobile () {
      this.phoneDisabled = true
      try {
        const res = await API.getMembersByMobile({
          mobile: this.fgPwdForm.phone
        })
        this.phoneDisabled = false
        if (res.data.statusCode === '200') {
          if (res.data.result.length === 0) {
            throw new Error('手机号未注册')
          }
          this.accounts = res.data.result
          this.fgPwdForm.account = this.accounts[0].username
        } else {
          throw new Error(res.data.message)
        }
      } catch (error) {
        this.phoneDisabled = false
        this.$message({
          message: error.message,
          type: 'error'
        })
      }
    }
  },
  mounted () {

  },
  activated () {

  },
  components: {
    AuthCode
  }
}
</script>

<style lang="stylus" scoped>
.fgpwd-dialog
  .el-dialog__body
    padding-top 10px
  .tp-fgpwd-dia-header
    font-size 16px
    padding-left 10px
    color theme-color
  .tp-fgpwd-form-w
    .tp-fgpwd-buttom-bt
      center()
</style>
